/* ================================
===    COMMON FUNCTIONS        ====
=================================== */
function decodeHtml(html) {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
} /* === decode html === */
function isFunction(functionToCheck) {
 var getType = {};
 return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
function alphanumeric_unique() {
  return new Date().getUTCMilliseconds() + Math.random().toString(36).split('').filter(function(value, index, self) {
    return self.indexOf(value) === index;
  }).join('').substr(2, 17);
} /* === return alphanumeric unique string === */

function theme_is_mobile(){
  return jQuery(window).outerWidth() <= mobile_breakpoint;
} /* === check if is mobile === */

function theme_has_class($element, _class){
  return $element.hasClass(_class);
} /* === element has class? === */

function theme_get_offset_top($element){
  var top=0;
  try {
      top=parseInt($element.offset().top);
    } catch (err) {}
  return top;
} /* === element return offset top === */

function post_view_child(child){
  return $post_view.find(child);
} /* === return $post_view child === */


function themeOpenWindow(url, winWidth, winHeight) { 
  var width = winWidth,
    height = winHeight,
    left = (jQuery(window).width() - width) / 2,
    top = (jQuery(window).height() - height) / 2,
    opts = 'status=1' +
    ',width=' + width + ',height=' + height + ',top=' + top + ',left=' + left;
  window.open(url, 'Sharer', opts);
} /* === OPEN WINDOW FUNCTION === */

function addParameterToUrl(url, parameterName, parameterValue, atStart/*Add param before others*/){
    var replaceDuplicates = true,
    clur = null;
    if(url.indexOf('#') > 0){
        clur = url.indexOf('#');
        urlhash = url.substring(url.indexOf('#'),url.length);
    } else {
        urlhash = '';
        clur = url.length;
    }
    sourceUrl = url.substring(0,clur);

    var urlParts = sourceUrl.split("?");
    var newQueryString = "";

    if (urlParts.length > 1)
    {
        var parameters = urlParts[1].split("&");
        for (var i=0; (i < parameters.length); i++)
        {
            var parameterParts = parameters[i].split("=");
            if (!(replaceDuplicates && parameterParts[0] === parameterName))
            {
                if (newQueryString === ""){
                    newQueryString = "?";
                } else{
                    newQueryString += "&";
                }
                newQueryString += parameterParts[0] + "=" + (parameterParts[1]?parameterParts[1]:'');
            }
        }
    }
    if (newQueryString === ""){
            newQueryString = "?";
    }

    if(atStart){
        newQueryString = '?'+ parameterName + "=" + parameterValue + (newQueryString.length>1?'&'+newQueryString.substring(1):'');
    } else {
        if (newQueryString !== "" && newQueryString !== '?'){
            newQueryString += "&";
        }
        newQueryString += parameterName + "=" + (parameterValue?parameterValue:'');
    }
    return urlParts[0] + newQueryString + urlhash;
} /* === add parameter to url === */

function on_ref_replace() {
  if (null !== top.location.href.match(/\?on=ref/) || null !== top.location.href.match(/\&on=ref/) || theme_has_class($themeBody,'referrer--multipage')) {

    try {
      var href=top.location.href;
      if (null ===  href.match(/[\?|&]on=ref/)) {
        href=addParameterToUrl(href, "on", "ref");
        window.history.pushState("string", null, href);
      }
    } catch (err) {}
    /* questa cosa viene fatta anche in header*/
    jQuery('a[href*="' + BLOG_INFO.base_domain + '"]').each(function() {
      var _href=jQuery(this).attr('href');
      if (!_href.match(/\?on=ref/) && !jQuery(this).hasClass('ab-item')) {
        _href=addParameterToUrl(_href, "on", "ref");
        jQuery(this).attr('href', _href);
      }
    });
    jQuery('.clickable[data-href*="' + BLOG_INFO.base_domain + '"]').each(function() {
      var _href=jQuery(this).attr('data-href');
      if (!_href.match(/\?on=ref/) && !jQuery(this).hasClass('ab-item')) {
        _href=addParameterToUrl(_href, "on", "ref");
        jQuery(this).attr('data-href', _href);
      }
    });
  }
} /* === add to every links in body param on=ref === */

function theme_clone_all() {
  jQuery('.theme--clone').each(function(index, el) {
    if (jQuery(jQuery(el).data('clone')).length) {
      jQuery(el).html(jQuery(jQuery(el).data('clone')).clone());
      if (!jQuery(el).hasClass('theme--clone--repeat')) {
        jQuery(el).removeClass('theme--clone').removeClass('theme--clone--repeat');
      }
      // if(jQuery(el).attr('cta--prev')){
      //   jQuery(el).find('.cta--prev').addClass(jQuery(el).attr('cta--prev'));
      // }
      // if(jQuery(el).attr('cta--next')){
      //   jQuery(el).find('.cta--next').addClass(jQuery(el).attr('cta--next'));
      // }
    } else {
      jQuery(el).hide();
    }
  });
} /* === clone every class .theme--clone === */

function theme_resize_video() {
  if (jQuery('.video_theme').length > 0) {
    jQuery('.video_theme').each(function() {
      var width = jQuery(this).outerWidth();
      jQuery(this).css('width', '100%').css("height",(width * aspectRatio)+"px");
      jQuery(this).find('#mp-playerContainer').css('width', '100%').css("height",(width * aspectRatio)+"px");
    });
  }
  if (jQuery('.mp_embed_post_video').length > 0) {
      jQuery('.mp_embed_post_video').each(function(index, el) {
          var $iframe = jQuery(el).find('iframe.video_theme');
          $iframe.css('width', '100%').css("height",($iframe.outerWidth() * aspectRatio)+"px").show();
      });
  }
} /* === resize every video === */

function receiveMessage(event){
  if(event.data.type==='playlistItem'){

    var item=event.data.item;
    jQuery('#mp_embed_post_video_'+item.parentid+' .video_theme_header_title h3 a')
            .html(item.title)
            .attr("alt",item.title)
            .attr('href',item.link);
    // jQuery('#mp_embed_post_video_'+item.parentid+' .video_theme_header_title h4 a')
    //         .html(item.author_name)
    //         .attr("alt",item.author_name)
    //         .attr('href',item.author_url);
    try {
      if(jQuery('#mp_embed_post_video_'+item.parentid+' .fb-like').attr('data-href')!==item.link && jQuery('#mp_embed_post_video_'+item.parentid+' .fb-like').parent()[0]){
          jQuery('#mp_embed_post_video_'+item.parentid+' .fb-like').attr('data-href',item.link);
          FB.XFBML.parse(jQuery('#mp_embed_post_video_'+item.parentid+' .fb-like').parent()[0]);
      }
    } catch (err) { }
    try {theme_resize_video();} catch (err) {}
  }
} /* === receiveMessage mp_embed === */


function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
}  /* === get parameter to url === */
function mpHasAttr(_element, _attr){
  return (typeof _element.attr(_attr) !== typeof undefined && _element.attr(_attr) !== false);
} /* === Check if element has attribute === */

function iframe_resize_fb(){
  jQuery('iframe:not(.mp-iframe)').each(function() {            
    var this_iframe=jQuery(this);
    var src=this_iframe.attr('src');
    if (src && (src.match("^https://www.facebook.com") || src.match("^http://www.facebook.com"))) {
      if(mpHasAttr(this_iframe,'width') && mpHasAttr(this_iframe,'height')){
        var real_width=this_iframe.attr("width");
        var parent_width=this_iframe.parent().outerWidth();
        var iframe_width=this_iframe.outerWidth();
        if(jQuery(window).outerWidth() <= container_width && parent_width && parent_width>0 && parent_width<=real_width){
          this_iframe.width(parent_width);          
          this_iframe.height(parent_width*this_iframe.attr("height")/this_iframe.attr("width"));
        } else if(jQuery(window).outerWidth() <= container_width && iframe_width && iframe_width>0 && iframe_width<=real_width){
          this_iframe.width(iframe_width);          
          this_iframe.height(iframe_width*this_iframe.attr("height")/this_iframe.attr("width"));
        }
      }
    }
    this_iframe.addClass('mp-iframe');
  });
} /* === resize iframe from facebook === */
function theme_change_title_and_url(document_title,link){
    document.title = document_title;
    window.history.pushState("string", null, link);

    // GOOGLE ANALITYCS CAMBIO PAGINA
    var newInfo = {
      location: location.href,
      title: document.title,
      contentGroup1: null,
      contentGroup2: null,
      contentGroup3: null,
      dimension1: null,
      dimension2: null,
      dimension3: null,
      dimension4: null,
      dimension5: null,
      dimension6: null,
      dimension7: null,
      dimension8: null,
      dimension9: null,
      dimension10: null
    };

    try {
      dataLayer.push({'event': 'infinitepage','newtitle': document.title,'newurl': location.href});
    } catch (err) {}
}/* === change url and document title === */
function theme_change_article_end() {
   try {        
      window.wp.gdrts.core.init();
      window.wp.gdrts.core.live();
    } catch (err) {}

    try { setTimeout(iframe_resize_fb,2000); } catch (err) {}

    theme_status_lazy_load();
}/* === to do after change article title / etc === */